import { render } from "./BreadCrumbs.vue?vue&type=template&id=8d545a40&scoped=true&ts=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=8d545a40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d545a40"]])

export default __exports__